var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 19.4163L34.4367 15.3363C35.109 14.9834 35.6722 14.4534 36.0652 13.8036C36.4582 13.1539 36.6662 12.4091 36.6667 11.6497V6.24967C36.6667 5.47613 36.3594 4.73426 35.8124 4.18728C35.2654 3.6403 34.5235 3.33301 33.75 3.33301H26.6667L25 11.6663L26.6667 19.4163Z",
    fill: "url(#paint0_linear_270_859)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3359 3.33301H6.2526C5.47906 3.33301 4.73719 3.6403 4.19021 4.18728C3.64323 4.73426 3.33594 5.47613 3.33594 6.24967V11.648C3.3361 12.4077 3.54394 13.1528 3.93699 13.8029C4.33003 14.453 4.89332 14.9832 5.56594 15.3363L13.3359 19.4163L15.0026 11.648L13.3359 3.33301Z",
    fill: "url(#paint1_linear_270_859)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3359 19.4163V3.33301H26.6693V19.4163L21.3576 22.2047C20.9396 22.424 20.4746 22.5385 20.0026 22.5385C19.5306 22.5385 19.0656 22.424 18.6476 22.2047L13.3359 19.4163Z",
    fill: "url(#paint2_linear_270_859)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3385 28.3333C28.3385 30.5435 27.4606 32.6631 25.8978 34.2259C24.335 35.7887 22.2153 36.6667 20.0052 36.6667C17.7951 36.6667 15.6755 35.7887 14.1127 34.2259C12.5498 32.6631 11.6719 30.5435 11.6719 28.3333C11.6719 26.1232 12.5498 24.0036 14.1127 22.4408C15.6755 20.878 17.7951 20 20.0052 20C22.2153 20 24.335 20.878 25.8978 22.4408C27.4606 24.0036 28.3385 26.1232 28.3385 28.3333Z",
    fill: "url(#paint3_radial_270_859)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_270_859",
    x1: 36.6667,
    y1: 4.76301,
    x2: 24.9433,
    y2: 17.1813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52D17C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A7F7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_270_859",
    x1: 3.33594,
    y1: 7.66467,
    x2: 15.1093,
    y2: 15.4563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52D17C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A7F7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_270_859",
    x1: 20.0026,
    y1: 0.931341,
    x2: 26.0693,
    y2: 20.6747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76EB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EC8B0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_270_859",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-24.3398 -38.334) rotate(56.615) scale(93.0292 79.6752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#FFCD0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#E67505"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsIcon);
export default __webpack_public_path__ + "static/media/points-icon.4ac80c27aa6dbea5f9132fb792fbef6f.svg";
export { ForwardRef as ReactComponent };